import { IMG } from "@/lib/images";

// TODO: paste the client's form backend (GoHighLevel webhook, Formspree URL, or API endpoint).
// While empty, forms validate and show a success state without a network call.
export const FORM_ENDPOINT = "";

// Contact details — placeholders to confirm/replace.
export const CONTACT = {
  phone: "323-831-0420",
  phoneHref: "tel:+13238310420",
  email: "hi@theaidept.com",
  address: "Los Angeles, CA",
  hours: "Guaranteed 1-hour human response time.",
};

// Social links — placeholder URLs to swap.
export const SOCIALS = [
  { label: "LinkedIn", icon: "linkedin", url: "https://www.linkedin.com/company/theaidept/" },
  { label: "Instagram", icon: "instagram", url: "https://www.instagram.com/chiefaiofficer" },
  { label: "YouTube", icon: "youtube", url: "https://www.youtube.com/@TheAIDept" },
];

// Brand cards — logo is rendered as an initials block; swap name/description/url.
export const BRANDS = [
  { name: "[Brand 1]", initials: "B1", description: "[What this brand does, in one line]", url: "https://example.com" },
  { name: "[Brand 2]", initials: "B2", description: "[What this brand does, in one line]", url: "https://example.com" },
  { name: "[Brand 3]", initials: "B3", description: "[What this brand does, in one line]", url: "https://example.com" },
  { name: "[Brand 4]", initials: "B4", description: "[What this brand does, in one line]", url: "https://example.com" },
  { name: "[Brand 5]", initials: "B5", description: "[What this brand does, in one line]", url: "https://example.com" },
  { name: "[Brand 6]", initials: "B6", description: "[What this brand does, in one line]", url: "https://example.com" },
];

// Leadership grid — placeholder names + headshots to swap.
export const LEADERSHIP = [
  { name: "Alex M.", role: "Founder & CEO", photo: IMG.clientAlex },
  { name: "Marcus R.", role: "Growth Team lead", photo: IMG.opMarcus },
  { name: "Jordan B.", role: "Creative director, Growth Team", photo: IMG.opJordan },
  { name: "Chris D.", role: "Workflow & Automation lead", photo: IMG.opChris },
];
